import {Navigate,useLocation} from 'react-router';

/** A legacy settings URL leaves operational building context without carrying private record filters. */
export function AdministrationRedirect({to}:{to:string}) {
  const location=useLocation(),engine=new URLSearchParams(location.search).get('engine');
  const search=to==='/admin/ai/agents'&&engine&&/^[a-z_]{2,40}$/.test(engine)?`?engine=${engine}`:'';
  return <Navigate replace to={to+search}/>;
}
